import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Spin} from 'antd'
import BatchesRows from './BatchesRows'
import '../../styles/index.scss'
import BulkSelect from './BulkSelect'
import BulkActions from './BulkActions'

class BatchesTable extends Component {
    state = {
        loadingSend: false,
        selectedItems: [],
        isSelectedAll: false
    }

    _toggleSelectAll = (isChecked) => {
        const {batches} = this.props
        if (isChecked) {
            const itemIds = batches.map(item => item._id)
            this.setState({
                selectedItems: itemIds,
                isSelectedAll: true
            })
        } else {
            this.setState({
                selectedItems: [],
                isSelectedAll: false
            })
        }
    }

    _handleSendLoading = (value) => {
        this.setState({
            loadingSend: value
        })
    }

    _updateSelectedOrders = (id, value) => {
        const {selectedItems} = this.state
        const {batches} = this.props
        if (value && !selectedItems.includes(id)) {
            this.setState({
                selectedItems: [...selectedItems, id],
                isSelectedAll: selectedItems.length + 1 === batches.length
            })
        } else {
            const filtered = selectedItems.filter(itemId => itemId !== id)
            this.setState({
                selectedItems: filtered,
                isSelectedAll: false
            })
        }
    }

    render() {
        const {loadingSend, isSelectedAll, selectedItems} = this.state
        const {loading, batches, onChangeProductType, refreshBatches, handleChangeInput, filters, onChangeMaterials} = this.props
        const { production_process } = filters || {}

        return (
            <div className='BatchesPageContainer'>
                <Spin spinning={loading} tip='Đang tải...'>
                    <table className='table table-borderless table-striped'>
                        <thead className='thead-light'>
                        {loadingSend ? (
                            <tr>
                                <BulkSelect isSelectedAll={isSelectedAll} selectedItems={selectedItems} loadingSend={loadingSend} toggleSelectAll={this._toggleSelectAll}/>
                                <th colSpan={13} className="position-relative">
                                    Sending...
                                </th>
                            </tr>
                        ) : selectedItems.length > 0 ? (
                            <tr>
                                <BulkSelect isSelectedAll={isSelectedAll} selectedItems={selectedItems} loadingSend={loadingSend} toggleSelectAll={this._toggleSelectAll}/>
                                <th colSpan={13} className="position-relative">
                                    <BulkActions refreshBatches={refreshBatches} batches={batches} selectedItems={selectedItems} toggleSelectAll={this._toggleSelectAll} handleSendLoading={this._handleSendLoading} filters={filters}/>
                                </th>
                            </tr>
                        ) : (
                            <tr>
                                <BulkSelect isSelectedAll={isSelectedAll} selectedItems={selectedItems} loadingSend={loadingSend} toggleSelectAll={this._toggleSelectAll}/>
                                <th className='Name'>Tên lô</th>
                                <th className="colDate">Ngày tạo</th>
                                <th className="colDate">Ngày in <br/> Quá hạn in</th>
                                <th className="colDate">Ngày ép <br/> Quá hạn ép</th>
                                <th className="colDate">Ngày may <br/> Quá hạn may</th>
                                <th className="ProductType">Loại sản phẩm</th>
                                <th className="text-center Quantity">
                                    Đang chờ / 
                                    {!!production_process ? 'Đã thiết kế' : 'QCSE'} / 
                                    {!!production_process ? 'Đã thêu' : 'Moved'} / Hoàn thành / Tổng
                                </th>
                                <th className="text-center Status">Trạng thái</th>
                                <th className="Partner text-center">Đối tác in ép</th>
                                <th className="Partner">Đối tác may</th>
                                <th className="text-center HumanCreate">Người tạo</th>
                                <th className="text-center Status">Xử lý</th>
                                <th className="Note">Ghi chú</th>
                            </tr>
                        )}
                        </thead>
                        <tbody>
                        {
                            batches.length > 0 ? (
                                batches.map(item => {
                                        return (
                                            <BatchesRows
                                                key={item._id} item={item}
                                                loadingSend={loadingSend}
                                                handleSendLoading={this._handleSendLoading}
                                                selectedItems={selectedItems}
                                                updateSelectedOrders={this._updateSelectedOrders}
                                                onChangeProductType={onChangeProductType}
                                                onChangeMaterials={onChangeMaterials}
                                                handleChangeInput={handleChangeInput}
                                            />
                                        )
                                    }
                                )
                            ) : (
                                <tr>
                                    <td colSpan={14}>No data</td>
                                </tr>
                            )
                        }
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }

}

BatchesTable.propTypes = {
    batches: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    onChangeProductType: PropTypes.func
}

export default BatchesTable
